import React from "react";

export default function About() {
  return (
    <div className="about" id="about">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>About</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <p>
              <span>HomerDoge</span> - this meme season we have chosen the best
              of the two, we got a lot of meme potential ! and we are developing
              an NFT passive income staking system where investors can mint and
              breed various Simpsons x Doge inspired NFT’s . and like our
              dogefather said ! :
            </p>
          </div>
          <div className="col-md-6 text-right">
            <img src="./Asserts/about-tweet.png" className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}
